import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-4d357b4c"),n=n(),_popScopeId(),n)
const _hoisted_1 = { id: "container" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h1", null, "遺伝子検査IDスキャン", -1))

import { useRouter } from "vue-router";
import axios from "axios";
import { useDogStore } from "@/stores/dog";
import useToastAlert from "@/composables/tostController";
import { useLoadingController } from "@/composables/loadingController"
import BarcodeScan from "@/components/BarcodeScan.vue";
import GeneticIdInput from "@/components/GeneticIdInput.vue";
import { home } from "ionicons/icons";
import {
  IonContent,
  IonHeader,
  IonPage,
  IonTitle,
  IonToolbar,
  IonButtons,
  IonButton,
  IonIcon,
  alertController,
} from "@ionic/vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'GeneticIdInputView',
  setup(__props) {

const dog = useDogStore()

const router = useRouter();

const { presentLoading, dismissLoading } = useLoadingController();

const handleEvent = (scannedCode: string): void => {
  dog.geneticId = scannedCode;
  useToastAlert("success", "遺伝検査ID スキャン成功");
};

const showConfirmDialog: any = async () => {
  const alert = await alertController.create({
    header: "確認",
    subHeader: dog.geneticId,
    message: `この遺伝子検査IDを${dog.animalName}ちゃんに登録しますか？`,
    buttons: [
      {
        text: "キャンセル",
        role: "cancel",
      },
      {
        text: "登録",
        role: "confirm",
        handler: () => {
          presentLoading('登録中...')
          const url = `https://api-bleeder-app-test.anicom-pafe.com/v1/microchip`;
          const data = {
            microchip: dog.microchipId,
            genetic_id: dog.geneticId,
          };
          axios.post(url, data, {timeout: 10000})
            .then(() => {
              dismissLoading()
              useToastAlert(
                "success",
                `正常に登録されました。`
              );
              router.push({
                name: "geneticIdResult",
              });
            })
            .catch(() => {
              dismissLoading()
              useToastAlert( "danger", `なんらかのエラーが発生しました。再度お試しください。`);
            });
        },
      },
    ],
  });
  await alert.present();
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(IonPage), null, {
    default: _withCtx(() => [
      _createVNode(_unref(IonHeader), { translucent: true }, {
        default: _withCtx(() => [
          _createVNode(_unref(IonToolbar), null, {
            default: _withCtx(() => [
              _createVNode(_unref(IonButtons), {
                slot: "end",
                "router-link": "/microchip/input",
                "router-direction": "root"
              }, {
                default: _withCtx(() => [
                  _createVNode(_unref(IonIcon), {
                    color: "primary",
                    size: "large",
                    icon: _unref(home)
                  }, null, 8, ["icon"])
                ]),
                _: 1
              }),
              _createVNode(_unref(IonTitle), null, {
                default: _withCtx(() => [
                  _createTextVNode("生体管理システム（β）")
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      }),
      _createVNode(_unref(IonContent), { fullscreen: true }, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_1, [
            _hoisted_2,
            _createVNode(BarcodeScan, { onCodeScanEvent: handleEvent }),
            _createVNode(GeneticIdInput, {
              geneticId: _unref(dog).geneticId,
              "onUpdate:geneticId": _cache[0] || (_cache[0] = ($event: any) => (_unref(dog).geneticId = $event))
            }, null, 8, ["geneticId"]),
            _createVNode(_unref(IonButton), {
              style: {"margin-top":"50px"},
              size: "large",
              expand: "block",
              disabled: !_unref(dog).hasGeneticId(),
              onClick: _cache[1] || (_cache[1] = () => showConfirmDialog())
            }, {
              default: _withCtx(() => [
                _createTextVNode("登録内容を確認する")
              ]),
              _: 1
            }, 8, ["disabled"])
          ])
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}
}

})